exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.name {\n  font-size: 32px;\n  font-weight: bold;\n  color: #000;\n}\n.desc {\n  color: #999;\n  font-size: 12px;\n}\n.col-title {\n  color: #666;\n  font-size: 14px;\n  text-align: center;\n}\n.col-val {\n  color: #000;\n  font-size: 28px;\n  font-weight: bold;\n  padding-top: 10px;\n  text-align: center;\n}\n", ""]);

// exports
